export default "__VITE_ASSET__60e815d5__"